import React from "react";
import "./GenericBoard.css";
import EventIcon from '@mui/icons-material/Event';
import PersonIcon from '@mui/icons-material/Person';
import BusinessCenterIcon from '@mui/icons-material/WorkOutline';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import CircleIcon from '@mui/icons-material/Circle';
import AssignmentIcon from '@mui/icons-material/Assignment';




const getNestedValue = (obj, path) =>
  path.split('.').reduce((acc, part) => acc && acc[part], obj);
interface GenericBoardProps {
  data: any[];
  config: any;
  openItemPopup?: (id: Number | string) => void;
  lookups?: Record<string, any>;
}

const GenericBoard: React.FC<GenericBoardProps> = ({ data, config, openItemPopup, lookups = {} }) => {
  const formatDate = (value) => {
    if (!value) return "";
    const date = new Date(value);
    if (isNaN(date.getTime())) return value;

    return date.toLocaleDateString("he-IL", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };



  const { categoryField, categories, displayFields, idField, actionLabel } = config;

  return (
    <div className="generic-board">
      <div className="board-columns">
        {categories.map(({ label, color }) => {
          const items = data.filter(item => getNestedValue(item, categoryField) === label);

          return (
            <div key={label} className="board-column">
              <div className="category-badge" style={{ backgroundColor: color }}>
                {label}
              </div>

              {items.map((item, index) => (
                <div
                  key={index}
                  className="board-item"
                  style={{ position: "relative" }}
                  onClick={(e) => {
                    e.stopPropagation(); // מונע מהכרטיס כולו להפעיל את ה־onClick
                    openItemPopup(item[config.idField]);
                  }}
                  role="button"
                  tabIndex={0}
                >
                  {displayFields.map(field => {
                    let value = getNestedValue(item, field.key);

                    if (
                      field.lookup &&
                      lookups[field.lookup] &&
                      typeof value !== "object"
                    ) {
                      const match = lookups[field.lookup].find(entry => {
                        const idKey = Object.keys(entry).find(k =>
                          k.toLowerCase().includes("id")
                        );
                        return entry[idKey] === String(value);
                      });

                      if (match) {
                        if (field.lookupLabel.includes(",")) {
                          const parts = field.lookupLabel
                            .split(",")
                            .map(k => match[k]?.trim())
                            .filter(Boolean);
                          value = parts.join(" ");
                        } else {
                          value = match[field.lookupLabel] || value;
                        }
                      }
                    }

                    return (
                      <div
                        key={field.key}
                        className={`item-field ${field.format === "date" ? "date" : ""}`}
                      >
                        {field.key === "fullName" || field.key === "assignedTo" ? (
                          <>
                            <PersonIcon fontSize="small" style={{ color: "#2c6d8f", marginLeft: 5 }} />
                            {value}
                          </>
                        ) : field.key === "projectId" || field.key === "businessName" ? (
                          <>
                            <BusinessCenterIcon fontSize="small" style={{ color: "#2c6d8f", marginLeft: 5 }} />
                            {value}
                          </>
                        )
                          : field.key === "taskName" ? (
                            <>
                              <AssignmentIcon fontSize="small" style={{ color: "#2c6d8f", marginLeft: 5 }} />
                              {value}
                            </>
                          ) : field.key === "email" ? (
                            <>
                              <EmailIcon fontSize="small" style={{ color: "#2c6d8f", marginLeft: 5 }} />
                              {value}
                            </>
                          ) : field.key === "phone" ? (
                            <>
                              <PhoneIcon fontSize="small" style={{ color: "#2c6d8f", marginLeft: 5 }} />
                              {value}
                            </>
                          ) : field.key === "levelUrgencyStatus" ? (
                            <>
                              {+(value) == 1 && <CircleIcon style={{ color: "#32CD32", position: "absolute", bottom: 8, left: 8, marginLeft: 5 }} />}
                              {+(value) == 2 && <CircleIcon style={{ color: "lightblue", position: "absolute", bottom: 8, left: 8, marginLeft: 5 }} />}
                              {+(value) == 3 && <CircleIcon style={{ color: "yellow", position: "absolute", bottom: 8, left: 8, marginLeft: 5 }} />}
                              {+(value) == 4 && <CircleIcon style={{ color: "red", position: "absolute", bottom: 8, left: 8, marginLeft: 5 }} />}
                            </>


                          ) : field.format === "date" ? (
                            <>
                              <EventIcon fontSize="small" style={{ color: "#2c6d8f" }} />
                              {formatDate(value)}
                            </>
                          ) : field.format === "₪" ? (
                            `${value} ₪`
                          ) : (
                            value
                          )}

                      </div>
                    );
                  })}



                </div>
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GenericBoard;
